import {FaFacebookF, FaMapMarkerAlt, FaInstagram} from 'react-icons/fa';
import {AiFillPhone, AiOutlineCopyright} from 'react-icons/ai';

const Footer = () => {

    return(
        <section className='mb-2'>
            <div className='mx-4'>
                <div className="row">
                    
                    
                </div>
                <div className='row'>
                    <div className='col-12 d-flex gap-4 justify-content-center footer-copy'>
                        <span><AiOutlineCopyright size={15}/> COPYRIGHT 2025 </span>
                        <span className='separator'> | </span>
                        <span>
                            <a href="#Inicio">AMT-CUSTOMS</a>
                        </span>
                        <span className='separator'> | </span>
                        <span>
                            <a href="https://www.yetiadvisers.com/" rel="noopener noreferrer nofollow" target="_blank">Powered By YETI ADVISERS</a>
                        </span>
                        {/* 
                        <div className='d-flex flex-row-reverse gap-2'>
                            <a href="https://www.facebook.com/AgrikGT/" rel="noopener noreferrer nofollow" target="_blank">
                                <FaFacebookF size={18}/>
                            </a>
                            <a href="https://www.instagram.com/agrikgt/" rel="noopener noreferrer nofollow" target="_blank">
                                <FaInstagram size={18}/>
                            </a>
                        </div>*/}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Footer